module.exports = __webpack_public_path__ + "img/rule.10014f89.svg";